import React, { lazy } from 'react';
import { useSetWidgetAttribute } from '../hooks/useSetWidgetAttribute.js';
import { useSelector } from 'react-redux';
import InputSkeleton from '../../../skeleton_loaders/common/InputSkeleton.jsx';
import styles from '../gen2_widgets/base/CommonSettings.module.scss';
import withSuspense from '../../../helpers/withSuspense.jsx';
import { widgetsNoTitle } from '../WidgetLibraryGen2';

const TextInput = withSuspense(lazy(() => import('../../common/TextInput.jsx')), InputSkeleton);

function WidgetTitleSettings({ widgetId }){
  const setAttribute = useSetWidgetAttribute(widgetId);
  const widgetTitle = useSelector(state => state.dashboard.widgets[widgetId].theme?.overrides?.common?.title?.text) || '';
  const widgetType = useSelector(state => state.dashboard.widgets[widgetId].widget_type);
  return (
        !widgetsNoTitle.includes(widgetType) && 
        <div className={`${styles['settings-option']} mb-1`}>
          <label>{I18n.t('widget_title')}</label>
          <TextInput id={`widget-title-${widgetId}`} value={widgetTitle} afterChange={(value) => setAttribute('theme.overrides.common.title.text', value)} />
        </div>
  )
}

export default WidgetTitleSettings;
